{
  "Clear search": "Rensa sökning"
}
